module.exports = __webpack_public_path__ + "static/assets/img/video3.a7c722e4.gif";